import { Flex, Text } from '@huspy/briks-web';
import { useTranslation } from 'react-i18next';
import ProgressionStepper from '@components/v2/ProgressionStepper';
import type { ProposalCreationEngine } from '@modules/proposals/presentation/v2/pages/ProposalCreation/hooks/useProposalCreationStateMachineEngine';
import useGetProposalCreationAsideLinks from '@modules/proposals/presentation/v2/pages/ProposalCreation/features/ProposalCreationAsideContent/hooks/useGetProposalCreationAsideLinks';

const ProposalCreationAsideContent = ({
  routeId,
  isLoading,
  stateMachine,
}: {
  routeId: string;
  isLoading: boolean;
  stateMachine: ProposalCreationEngine.StateMachine;
}) => {
  const { t } = useTranslation();
  const { asideLinks } = useGetProposalCreationAsideLinks({ stateMachine });

  return (
    <Flex gap={ 10 } direction='column'>
      <ProgressionStepper
        routeId={ routeId }
        links={ asideLinks }
        header={ (
          <Text size='4xl' weight='medium'>
            {t('proposals.asideContent.title')}
          </Text>
        ) }
        isLoading={ isLoading }
      />
    </Flex>
  );
};

export default ProposalCreationAsideContent;
